import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import { fetchApi } from '@/config/axiosSetting';
import { AddDamagedPointQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedPoint/addDamagedPointQuery.type';

export const addDamagedPointFunction = async (
  params: AddDamagedPointQueryParamsType,
) => {
  const formData = new FormData();
  formData.append('part', params?.part.toString());
  const image = ConvertUrlToFile(params.image, 'image', 'image');

  formData.append('image', image);

  if (params.participantRoleType === 'initial') {
    return fetchApi.post(
      `/initial/reports/${params.id}/images/adjuster/vehicle/damaged_parts/`,
      formData,
      { params },
    );
  }
  if (params.participantRoleType === 'damaged') {
    return fetchApi.post(
      `/property/reports/${params.id}/accident_users/damaged/adjuster/vehicle/damaged_parts/`,
      formData,
      { params: { damaged_id: params.damaged_id } },
    );
  }
  if (params.participantRoleType === 'culprit') {
    return fetchApi.post(
      `/property/reports/${params.id}/accident_users/culprit/adjuster/vehicle/damaged_parts/`,
      formData,
    );
  }
  if (params.participantRoleType === 'body') {
    return fetchApi.post(
      `/body/reports/${params.id}/images/adjuster/vehicle/damaged_parts/`,
      formData,
    );
  }
};
